import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State để quản lý toggle
  const location = useLocation();

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev); // Đổi trạng thái menu
  };

  useEffect(() => {
    // Cuộn lên đầu mỗi khi pathname thay đổi
    window.scrollTo(0, 0);

    // Đóng menu khi chuyển trang
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="nav-logo">PORTFOLIO</Link>
      </div>
      {/* Toggle button */}
      <div 
        className={`toggle-button ${isMenuOpen ? 'active' : ''}`} 
        onClick={handleToggleMenu}
        aria-label="Toggle navigation menu"
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
      {/* Navigation links */}
      <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <Link
          to="/"
          className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}
        >
          Home
        </Link>
        <Link
          to="/about"
          className={`nav-item ${location.pathname === '/about' ? 'active' : ''}`}
        >
          About
        </Link>
        <Link
          to="/skill"
          className={`nav-item ${location.pathname === '/skill' ? 'active' : ''}`}
        >
          Skills
        </Link>
        <Link
          to="/project"
          className={`nav-item ${location.pathname === '/project' ? 'active' : ''}`}
        >
          Projects
        </Link>
        <Link
          to="/contact"
          className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}
        >
          Contact
        </Link>
        {/* <Link
          to="/gift"
          className={`nav-item ${location.pathname === '/gift' ? 'active' : ''}`}
        >
          Gift
        </Link> */}
      </div>
    </nav>
  );
};

export default Navbar;